import React, { CSSProperties, useEffect, useRef } from 'react';
import { EditorMenus, EditorNewHtml } from './rich-text';
import Editor from 'wangeditor';
// eslint-disable-next-line no-duplicate-imports
import WangEditor from 'wangeditor';
import AliOssUpload from '@/utils/aliOssUpload';
import './rich-text.less';
import { uuid } from '@/utils';

interface PropsValue {
    style?: CSSProperties; // 盒子样式可以自己加
    onchange?: (v: EditorNewHtml) => void; //  change 事件
    onblur?: (v: EditorNewHtml) => void; // 失去焦点事件
    onfocus?: (v: EditorNewHtml) => void; // 聚焦事件
    onpaste?: (v: EditorNewHtml) => void; // 粘贴处理
    onImage?: (src: string, alt: string, href: string) => void; // 拿图片回调参数
    onUploadImg?: (file: File) => string; // 自定义上传，不定义默认用阿里云地址
    menus?: EditorMenus; // 菜单扩充
    excludeMenus?: EditorMenus; // 菜单去除
    disabled?: boolean; // 是否禁用富文本
    selfValue?: EditorNewHtml; // 自定义富文本传值
    value?: EditorNewHtml; // 由于ant form表单会控制自props value传值，自定义外部修改富文本用selfValue
    isFullScreen?: boolean; // 是否全屏
    placeholder?: string; // 默认提示
    rowKey?: string; //  同页面创建多个富文本请传不同key实例化富文本
}

// 初始化默认存在的
// const initialMenus: EditorMenus = ['bold', 'kityformulaKey', 'image', 'italic', 'underline', 'table', 'undo', 'redo'];
const initialMenus: EditorMenus = ['bold', 'kityformulaKey', 'italic', 'underline', 'table', 'undo', 'redo'];
const getMergedMenus = (menuLists: EditorMenus, menus?: EditorMenus, excludeMenus?: EditorMenus) => {
    let newMenus = menus ? [...menuLists, ...menus] : [...menuLists];
    newMenus = Array.from(new Set(newMenus));
    newMenus.filter(val => excludeMenus?.includes(val));
    return newMenus;
};

const RichText: React.FC<PropsValue> = props => {
    console.log(props)
    const editorId = props.rowKey || `wang-rich-text-${uuid()}`; // 富文本编辑器实例化id节点
    const aliUploadId = `rich-text-container-${uuid()}`; // 阿里云上传
    const editor = useRef<Editor | null>(null);
    const isInit = useRef(false);

    const init = () => {
        isInit.current = false;
        const { menus, excludeMenus, placeholder, value } = props;
        // 创建编辑器
        editor.current = new WangEditor(`#${editorId}`);
        // 创建阿里云上传
        const aliOssUpload: AliOssUpload = new AliOssUpload({
            container: aliUploadId,
            dir: 'new-znb-img',
            multi_selection: false,
            filenameType: 'random_name',
        });

        // 编辑器config配置在组件内部，有需要在特定配置暴露在外
        editor.current.config.uploadImgMaxLength = 5; // 一次最多上传 5 个图片
        editor.current.config.pasteFilterStyle = false; // 关闭粘贴样式的过滤
        editor.current.config.pasteIgnoreImg = true; // 忽略粘贴的图片
        editor.current.config.placeholder = placeholder || '请输入正文';
        // // 默认情况下，只有 IE 和 旧版 Edge 会使用兼容模式，如果需要在其它浏览器上也使用兼容模式，可以在函数内进行判定
        // editor.current.config.compatibleMode = () => {
        //     // 返回 true 表示使用兼容模式；返回 false 使用标准模式
        //     return true;
        // };
        // 配置触发 onchange 的时间频率，默认为 200ms, 只在兼容模式下生效！！！
        editor.current.config.onchangeTimeout = 500; // 修改为 500ms
        // 自定义扩展
        // editor.current.menus.extend('kityformulaKey', mathematicalFunction(editor.current));

        editor.current.config.menus = getMergedMenus(initialMenus, menus, excludeMenus); // 自定配置义菜单

        editor.current.config.onchange = (newHtml: EditorNewHtml) => {
            if (!isInit.current) return;
            // 配置 onchange 回调函数
            if (props.onchange) {
                props.onchange(newHtml);
            }
        };

        editor.current.config.onblur = (newHtml: EditorNewHtml) => {
            // 失去焦点
            if (props.onblur) {
                props.onblur(newHtml);
            }
        };

        editor.current.config.onfocus = (newHtml: EditorNewHtml) => {
            // 聚焦
            if (props.onfocus) {
                props.onfocus(newHtml);
            }
        };

        editor.current.config.pasteTextHandle = (pasteStr: EditorNewHtml) => {
            // 富文本粘贴复制处理
            if (props.onpaste) {
                return props.onpaste(pasteStr);
            }
            return pasteStr;
        };

        editor.current.config.linkImgCallback = function (src: string, alt: string, href: string) {
            // 图片处理的回调
            if (props.onImage) {
                props.onImage(src, alt, href);
            }
        };
        editor.current.config.customUploadImg = async function (resultFiles: any, insertImgFn: any) {
            let src = '';
            // 自定义上传图片，将图片上传到阿里云
            if (props.onUploadImg) {
                src = await props.onUploadImg(resultFiles[0]);
            } else {
                const ret: any = await aliOssUpload.uploadFileObj(resultFiles[0]);
                src = ret[0];
            }
            insertImgFn(src);
        };

        editor.current.create(); // 创建

        if (props.value) {
            setTimeout(() => {
                editor.current?.txt.html(props.value);
                setTimeout(() => (isInit.current = true), 100);
            }, 500);
        } else {
            isInit.current = true;
        }
    };

    // didMount
    useEffect(() => {
        init();
        return () => {
            editor.current?.destroy();
        };
    }, []);

    // useEffect(() => {
    //     setTimeout(() => {
    //         if (props.value) {
    //             editor.current?.txt.html(props.value);
    //         }
    //     }, 500);
    // }, []);

    useEffect(() => {
        // 富文本禁用
        if (props.disabled) {
            editor.current?.disable();
            return;
        }
        editor.current?.enable();
    }, [props.disabled]);

    useEffect(() => {
        // 控制value
        if (props.selfValue) {
            editor.current?.txt.html(props.selfValue);
            return;
        }
        editor.current?.txt.clear();
    }, [props.selfValue]);

    useEffect(() => {
        // 控制全屏
        if (props.isFullScreen) {
            editor.current?.fullScreen();
            return;
        }
        editor.current?.unFullScreen();
    }, [props.isFullScreen]);

    return (
        <>
            <div id={aliUploadId} style={{ display: 'none' }}>
                <div id="selectfiles" />
                <div id="postfiles" />
            </div>
            <div id={editorId} style={props.style} />
        </>
    );
};

export default RichText;
